// Function to validate hex color and provide fallback
export const validateColor = (color, fallback) => {
  // Check if color is undefined or null
  if (!color) return fallback

  // Check if it's a valid hex color (6 characters, valid hex digits)
  const hexColorRegex = /^[0-9A-Fa-f]{6}$/
  if (!hexColorRegex.test(color)) return fallback

  return color
}

// Default colors
export const DEFAULT_PRIMARY_COLOR = '19d412'
export const DEFAULT_SECONDARY_COLOR = '030021'
